import { render, staticRenderFns } from "./MerchantBank.vue?vue&type=template&id=504b7d03&scoped=true"
import script from "./MerchantBank.vue?vue&type=script&lang=js"
export * from "./MerchantBank.vue?vue&type=script&lang=js"
import style0 from "./MerchantBank.vue?vue&type=style&index=0&id=504b7d03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b7d03",
  null
  
)

export default component.exports